// Zod schemas for every server input. Server never trusts the client.

import { z } from 'zod';

export const deviceInput = z.object({
  device_id: z.string().min(8).max(64).regex(/^[A-Za-z0-9_-]+$/),
  label: z.string().max(64).optional(),
});

export const signupInput = z.object({
  email: z.string().email().max(254),
  password: z.string().min(10).max(72),
});

export const loginInput = z.object({
  email: z.string().email().max(254),
  password: z.string().max(72),
});

export const resetInput = z.object({
  email: z.string().email().max(254),
});

export const tokenResponse = z.object({
  token: z.string(),
  claims: z.object({
    sub: z.string(),
    did: z.string(),
    plan: z.string(),
    status: z.string(),
    entitlements: z.object({ export: z.boolean(), watermark: z.boolean() }),
    iat: z.number(),
    exp: z.number(),
    gu: z.number(),
  }),
});

export type DeviceInput = z.infer<typeof deviceInput>;
export type TokenResponse = z.infer<typeof tokenResponse>;
